// extracted by mini-css-extract-plugin
export default {"programsTable":"programList_programsTable__vUKKU"};